import React from 'react';

function SignupForm(_: {}) {
  return (
    <div>
      <div>
        <p>Með Rauntímatextun Tiro getur þú textað útsendingar þínar um leið og þær eiga sér stað.</p>
        <h3>Sæktu um</h3>
        <p>
          Til að fá aðgang að Rauntímatextun Tiro skal sækja um með tölvupósti á{' '}
          <a href='mailto:tiro@tiro.is'>tiro@tiro.is</a> og munum við hafa samband við þig um hæl.
        </p>
      </div>
    </div>
  );
}

export default SignupForm;
